export default __webpack_public_path__ + "static/media/type-1.5638d87c.svg";